<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'w-10'
    ]"
    alt="Stripe logo"
    src="@/assets/image/logo-stripe.svg"
  />
</template>